import { ROLES } from '../../auth/constants';

const config = {
  SITE: 'quality',
  LABEL: 'Quality',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,8b771ee4-a7d7-460c-9a24-7ffcf9e10b58',
  PAGES_LIST_ID: 'e3ebc7ac-0798-4ca1-82fc-1fe77b512766',
  DOCUMENTS_LIST_ID: '2fbcea89-6532-4b67-a3b1-5dd153c92ed0',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1isZ3NJnA66Rp6xgI_efN2-',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1iJ6rwvMmVnS6OxXdFTyS7Q',
  NEWS_TEMPLATE_ID: 'b66907ef-e433-452e-95a4-bebec8f02563',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  OPT_OUT_FILE_PATH: 'Settings/EmailOptOut.txt',
  MANAGER_ROLES: [ROLES.QSE_MGR],
  VIVA_COMMUNITY_ID: undefined,
  libraryDrives: [
    {
      name: 'Quality Food Safety',
      label: 'Quality & Food Safety',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1hGVuLIfCUUToWo8UC-lHwY',
      listId: 'c8e25646-257c-4e14-85a8-f140be947c18'
    },
    {
      name: 'Requirements',
      label: 'QFS Requirements',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1jVnWkrdf-JQqI4y_cC250U',
      listId: '2b699dd5-ff75-4289-a238-cbf702db9d14'
    },
    // {
    //   name: 'FSOP',
    //   label: 'FSOP',
    //   driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1iO95RdRtwLRLtNsYwaVL3L',
    //   listId: '5d94f78e-dc46-440b-bb4d-b18c1a54bdcb'
    // },
    {
      name: 'Supplier',
      label: 'Supplier Quality',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1j4rIlsIxeIT7Rg-7-e0oXt',
      listId: '6c89acf8-1723-4f88-b460-fbbf9ed285ed'
    },
    {
      name: 'Destruction Facilities',
      label: 'Destruction Facilities',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1gvD6hX_u7ETYu7DCk3ltEx',
      listId: '57a80f2f-eefe-4dc4-8bbb-0c293796d131'
    }
  ]
}

export default config